import { useCurrentAmount } from './useCurrentAmount';
import { useGetBuyerSpendingLimit } from '../../../api/lending/lapiHooks';
import { durationFromPricingOption } from '../../utils/product';
import {
  MAX_AMOUNT_PAY_LATER,
  MIN_AMOUNT_PAY_LATER,
} from '../PaymentDetails/PaymentDetails';
import { TPricingOption } from '../utils/PayLinkLanding.types';

export const useHasInsufficientCredit = ({
  pricingOption,
}: {
  pricingOption: TPricingOption;
}) => {
  const { spendingLimit, loadingSpendingLimit } = useGetBuyerSpendingLimit();
  const amount = useCurrentAmount();
  const duration = durationFromPricingOption[pricingOption];

  const hasValidSpendingLimit = Boolean(
    spendingLimit?.data.active_spending_limit?.is_valid,
  );

  const getHasInsufficientCredit = () => {
    if (pricingOption === 'payNow') return false;

    // Only consider valid pay later amounts
    if (
      !amount ||
      parseFloat(amount) < MIN_AMOUNT_PAY_LATER ||
      parseFloat(amount) > MAX_AMOUNT_PAY_LATER
    )
      return false;

    const availableCredit =
      spendingLimit?.data.spending_limits.find(
        (limit) => limit?.duration_in_months === duration,
      )?.available_amount || 0;

    // If they have no spending limit, we need to allow them to apply for one.
    if (!hasValidSpendingLimit) return false;

    return availableCredit < parseFloat(amount);
  };

  return {
    hasInsufficientCredit: getHasInsufficientCredit(),
    loadingHasInsufficientCredit: loadingSpendingLimit,
  };
};
